import "./alt_info_sliders.css";
